import * as React from "react";
// import styled from "styled-components";

import * as releaseAdmin from '../../sdk/release-admin';

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { ReleaseGrid } from '../../controllers/releases/release-grid';
import { ReleaseIndexSchema } from '../../../../../services/search-admin/types/index-schema/release-index-schema';
import { MAX_ASSIGNMENT_BATCH_SIZE } from '../../../../../services/release-admin/constants';
import { useHistory } from 'react-router';
import { routes } from '../../routes';

export const UserInboxPage: React.FC = () => {
  
  const history = useHistory();

  const [loadingAssign, setLoadingAssign] = React.useState(false);
  const [assignmentList, setAssignmentList] = React.useState<string[]>([]);

  const [loadingTotal, setLoadingTotal] = React.useState(false);
  const [totalPending, setTotalPending] = React.useState(0);

  const [releases, setReleases] = React.useState<ReleaseIndexSchema[]>([]);

  React.useEffect(() => {
    setLoadingTotal(true);

    releaseAdmin
      .getTotal("pending")
      .then((res) => setTotalPending(res.total))
      .finally(() => setLoadingTotal(false));

    releaseAdmin
      .listByStatus("pending")
      .then((res) => setReleases(res.results))
      .finally(() => setLoadingAssign(false));
  }, []);

  const handleAssignBatch = async () => {
    setLoadingAssign(true);
    try {
      const result = await releaseAdmin.assignBatch();
      setAssignmentList(result.map((r) => r.releaseId));
      setTotalPending(totalPending - result.length)
    } finally {
      setLoadingAssign(false);
    }
  }
  return (
    <section>
      <Toolbar
        variant="dense"
        style={{ marginTop: "20px", display: "flex", flexWrap: "wrap" }}
      >
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Your Inbox
        </Typography>
        {loadingTotal ? null : <Typography>Total Pending: { totalPending }</Typography>}
        <Button color={!assignmentList.length ? 'primary' : 'inherit'} variant={assignmentList.length < MAX_ASSIGNMENT_BATCH_SIZE && !loadingAssign ? 'outlined' : 'text'} disabled={assignmentList.length >= MAX_ASSIGNMENT_BATCH_SIZE} onClick={handleAssignBatch} style={{marginLeft: '1rem'}}>
          { loadingAssign ? <CircularProgress size='1.5rem' /> : 'Assign Batch' }
        </Button>
      </Toolbar>
      <div style={{ display: "flex", height: "700px", marginTop: "20px" }}>
        <ReleaseGrid
          releases={releases}
          size={releases.length}
          loading={loadingAssign}
          handleClick={(release, ev) => {
            const url = `${routes.releases.list}/${release.id}`;
            if (ev.ctrlKey || ev.metaKey) {
              window.open(url, '_blank')
            } else {
              history.push(url, { from: 'inbox' })
            }
          }}
        />
      </div>
    </section>
  );
};
